import crud from "./crud";
import crud_service from "@/services/crud";

const path = "production_loss_periods";
const struct = {
  producer_id: null,
  start: null,
  end: null,
  loss_kwh: 0,
  category_id: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
  contextItems: [],
  selectedPeriod: null,
};

const getters = {
  ...generic.getters,
  contextItems: (state) => state.contextItems,
  selectedPeriod: (state) => state.selectedPeriod,
};

const mutations = {
  ...generic.mutations,
  setContextItems(state, items) {
    state.contextItems = items;
  },
  setSelectedPeriod(state, period) {
    state.selectedPeriod = period;
  },
};

const actions = {
  ...generic.actions,

  getWithContext({ commit }, options) {
    let payload = {};
    if (options) {
      if (options.producer) payload.producer = options.producer;
      if (options.start) payload.start = options.start;
      if (options.end) payload.end = options.end;
      if (options.category) payload.category = options.category;
      if (options.is_normal_operation !== undefined)
        payload.is_normal_operation = options.is_normal_operation;
    }
    commit("setIsLoading", true);
    return new Promise((resolve, reject) => {
      crud_service
        .fetch(`${path}/with_context`, payload)
        .then((items) => {
          commit("setContextItems", items.results);
          commit("setItems", items.results);
          commit("setPagination", items);
          commit("setIsLoading", false);
          resolve(items.results);
        })
        .catch(() => {
          commit("setIsLoading", false);
          reject();
        });
    });
  },

  selectPeriod({ commit }, period) {
    commit("setSelectedPeriod", period);
  },

  addNote(_, { loss_period_id, text }) {
    return crud_service.post("production_loss_notes", {
      loss_period_id,
      text,
    });
  },

  deleteNote(_, noteId) {
    return crud_service.delete("production_loss_notes", noteId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
